import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-debug-snackbar',
    templateUrl: './debug-snackbar.component.html',
    styleUrls: ['./debug-snackbar.component.scss']
})
export class DebugSnackbarComponent {

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string,
                private readonly ref: MatSnackBarRef<DebugSnackbarComponent>) {}

    public close() {
        this.ref.dismiss();
    }

}
